module.exports = __webpack_public_path__ + "img/thank-you.11909538.png";